import { IParty, ITable, ServerResponse } from '../../models/models'
import { EditableParty } from '../../pages/Parties/EditPartiesModal/schema'
import { api } from '../api'

export const partiesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getParties: builder.query<ITable<IParty>, any>({
			query: (params) => ({
				url: 'parties',
				params,
			}),
			providesTags: ['parties'],
			transformResponse: (response: ServerResponse<ITable<IParty>>) => ({
				...response.data,
				data: response.data.data.map((i) => ({ ...i, entityId: i.id })),
			}),
		}),
		getPartyById: builder.query<IParty, any>({
			query: (id) => ({
				url: `parties/${id}`,
			}),
			transformResponse: (response: ServerResponse<IParty>) => response.data,
		}),
		editParty: builder.mutation<IParty, { id: string | number; data: EditableParty }>({
			query: (body) => ({
				url: `parties/${body.id}`,
				method: 'PUT',
				body: body.data,
			}),
			invalidatesTags: ['parties'],
			transformResponse: (response: ServerResponse<IParty>) => response.data,
		}),
	}),
})

export const { useGetPartiesQuery, useLazyGetPartyByIdQuery, useEditPartyMutation } = partiesApi
